import { AxiosRequestConfig } from "axios";
import axios from "../Config/Axios";
import * as _ from "lodash";
import { TemplateObject } from "../Models/TemplateObject";
import { readCookie } from "../Util/helper";

const fetchTemplates = async ({
  endPoint,
  jsonFileName,
  config,
}: {
  endPoint: string;
  jsonFileName: string;
  config?: AxiosRequestConfig;
}) => {
  const finalUrl = `/${endPoint.replace(
    /\/$/,
    ""
  )}/assets/json/${jsonFileName}`;

  console.log("[fetchTemplates]");
  console.log("  endPoint:", endPoint);
  console.log("  jsonFileName:", jsonFileName);
  console.log("  finalUrl:", finalUrl);

  return await axios.get(finalUrl, config);
};

const getTemplateHtml = async ({
  endPoint,
  templateKey,
  state,
  config,
}: {
  endPoint: string;
  templateKey: string;
  state?: string;
  config?: AxiosRequestConfig;
}) => {
  // Extract template number from templateKey (e.g., "temp1" -> "1")
  const templateNumber = templateKey.replace(/[^0-9]/g, "") || "1";

  let templatePath;

  if (state) {
    // For state-specific templates
    templatePath = `/${endPoint}/temp/${_.capitalize(
      state
    )}/${templateKey}.html`;
  } else {
    // For regular templates
    templatePath = `/${endPoint}/temp/temp${templateNumber}.html`;
  }

  console.log("[getTemplateHtml]");
  console.log("  endPoint:", endPoint);
  console.log("  templateKey:", templateKey);
  console.log("  templateNumber:", templateNumber);
  console.log("  state:", state);
  console.log("  templatePath:", templatePath);

  return await axios.get(templatePath, config);
};

const getTemplatePaperType = async ({
  html,
  paperSize,
  config,
}: {
  html: string;
  paperSize: string;
  config?: AxiosRequestConfig;
}) => {
  return await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/request-paper-size`,
    { html, paperSize },
    config
  );
};

const processFormRequest = async ({
  formData,
  config,
}: {
  formData: TemplateObject;
  config?: AxiosRequestConfig;
}) => {
  return await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/process-request`,
    { ...formData },
    config
  );
};

const createDoc = async (data: any) => {
  console.log("path ", process.env.REACT_APP_DOCBUILDER_URL);
  const jwtToken = readCookie("jwtToken");
  const headers: object = { Authorization: "Bearer" + " " + jwtToken };
  const createDocEndpoint = `${process.env.REACT_APP_DOCBUILDER_URL}/doc`;
  return await axios.post(createDocEndpoint, data, headers);
};

const createParagraphService = async (docId: string, data: object) => {
  const jwtToken = readCookie("jwtToken");
  const headers: object = { Authorization: "Bearer" + " " + jwtToken };
  const createParaEndPoint = `${process.env.REACT_APP_DOCBUILDER_URL}/doc/${docId}/paragraph`;

  return await axios.post(createParaEndPoint, data, headers);
};

const updateParagraphService = async (
  docId: string,
  paraId: string,
  data: object
) => {
  const jwtToken = readCookie("jwtToken");
  const headers: object = { Authorization: "Bearer" + " " + jwtToken };
  const updateParagraphEndpoint = `${process.env.REACT_APP_DOCBUILDER_URL}/doc/${docId}/paragraph/${paraId}`;
  return await axios.put(updateParagraphEndpoint, data, headers);
};

const updateDoc = async (docId: string, data: any) => {
  console.log(" update path ", process.env.REACT_APP_DOCBUILDER_URL);
  const updateDocName = `${process.env.REACT_APP_DOCBUILDER_URL}/doc/${docId}`;
  return await axios.put(updateDocName, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getPdfSimpliDoc = async (docId: string) => {
  const jwtToken = readCookie("jwtToken");
  const headers: object = { Authorization: "Bearer" + " " + jwtToken };
  const getDocEndpoint = `${process.env.REACT_APP_DOCBUILDER_URL}/doc/${docId}`;
  return await axios.get(getDocEndpoint, headers);
};

export {
  fetchTemplates,
  getTemplateHtml,
  getTemplatePaperType,
  processFormRequest,
  createDoc,
  createParagraphService,
  updateParagraphService,
  getPdfSimpliDoc,
  updateDoc,
};
